export default __webpack_public_path__ + "static/media/atom-i-host.6b6dfcdb.svg";